import { connect } from 'react-redux';
import NewsBlock from '../components/NewsBlockComponent';
import {
    getNewsDataIfNeeded, getFilteredNewsIfNeeded, checkForNewNews,
} from '../actions/NewsActions';

const mapStateToProps = (state) => ({
    newsPageData: state.news.newsPageData,
    newsFiltered: state.news.newsFiltered,
    currentCategorySlug: state.news.currentCategorySlug,
    isLoading: state.news.isLoading,
    newsId: state.news.dataSingleNews.newsId,
    breakpoint: state.breakpointReducer,
});
const mapDispatchToProps = (dispatch) => ({
    getNewsDataIfNeeded: (qtdNews, qtdInit) => {
        dispatch(getNewsDataIfNeeded(qtdNews, qtdInit));
    },

    checkForNewNews: (category) => {
        dispatch(checkForNewNews(category));
    },

    getFilteredNewsIfNeeded: (qtdNews, qtdInit, category) => {
        dispatch(getFilteredNewsIfNeeded(qtdNews, qtdInit, category));
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(NewsBlock);

